// i18next-extract-mark-ns-start common
import * as React from 'react';
import landing from 'static/images/landing.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden bg-dark-grey pt-24 sm:pt-32 lg:pt-8  border-b-[42px] border-adw-blue">
      <div className="mx-auto max-w-6xl md:px-6 lg:px-8 pb-12">
        <div className="grid grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:grid-cols-2 lg:items-start">
          <div className="px-6 md:px-0 lg:pt-4 lg:pr-4">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
              <h2 className="text-4xl font-bold  text-white">
                {t('Vždy sa')}
                <br />
                <span className="font-black text-5xl text-adw-blue">
                  {' '}
                  {t('SNAŽÍME')}{' '}
                </span>
                {t('spraviť viac')}
              </h2>
              <p className="mt-6 text-lg  text-white">
                {t(
                  'Pri akomkoľvek zadaní a akejkoľvek požiadavke klienta sa pozeráme ďalej, a chceme urobiť pre Vás viac ako by možno iným stačilo.',
                )}
              </p>
            </div>
          </div>
          <div className="sm:px-6 lg:px-0 flex justify-center">
            <img
              alt="some thing"
              className="object-center"
              src={landing}
              width="70%"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
